<template>
  <div class="tree-style asset-manage">
    <ConfigBackupModal ref="ConfigBackupModal" v-on:execComplete="handleScan"></ConfigBackupModal>
    <ConfigSyncModal ref="ConfigSyncModal" v-on:execComplete="syncServer"></ConfigSyncModal>
    <Drawer
      :title="serverChangeModalTitle"
      v-model="serverChangeModal"
      width="500"
      :mask-closable="true"
      @on-close="serverChangeModalClose">
      <Form :model="serverForm" ref="serverForm" :rules="serverFormRule" :label-width="85" label-position="right">
        <FormItem label="设备管理地址" prop="asset_ip">
          <Input v-model="serverForm.asset_ip"/>
        </FormItem>
        <FormItem label="品牌" prop="brand">
          <Select v-model="serverForm.brand" style="min-width:200px" clearable>
            <Option v-for="item in brandList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="设备类型" prop="asset_type">
          <Select v-model="serverForm.asset_type" clearable>
            <Option v-for="item in assetTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="协议类型" prop="protocol">
          <Select v-model="serverForm.protocol" clearable @on-change="handleCertificate">
            <Option v-for="item in protocalList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="端口" prop="port">
          <Input  v-model="serverForm.port" number />
        </FormItem>
        <!-- <FormItem label="SNMP Community" prop="community">
          <Input v-model="serverForm.community"/>
        </FormItem> -->
        <FormItem label="管理员账号" prop="admin_user">
          <Input v-model="serverForm.admin_user"/>
        </FormItem>
        <FormItem label="管理员密码" prop="admin_pwd">
          <Input type="password" v-model="serverForm.admin_pwd"/>
        </FormItem>
        <FormItem label="备注">
          <Input type="textarea" v-model="serverForm.description" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeServerSubmit">提交</Button>
          <Button style="margin-left: 8px" @click="serverChangeModalClose">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Drawer
      :title="editServerModalTitle"
      v-model="editServerModal"
      width="720"
      :mask-closable="true"
      @on-close="editServerModalCancel">
      <transfer
        :data="no_select_server"
        :target-keys="editServerForm.server"
        :list-style="listStyle"
        @on-change="editServerChange"
        filterable></transfer>
      <Row :style="{marginTop: '20px'}">
        <Button type="primary" @click="editServerForGroupSubmit">提交</Button>
        <Button style="margin-left: 8px" @click="editServerModal = false">取消</Button>
      </Row>
    </Drawer>

    <Row class="" :style="{padding: '10px 10px', borderRadius: '3px'}">
      <Col v-bind:span="serverGroupSpan">
        <Card>
          <Button @click="ServerGroupShowBtn(false)" v-show="ServerGroupIsShow" type="primary" size="small" :style="{float: 'right', marginRight: '20px'}" class="mob-hidden">
            <Icon type="ios-arrow-back" />
          </Button>
          <Button @click="ServerGroupShowBtn(true)" v-show="!ServerGroupIsShow" type="primary" size="small" :style="{float: 'right', marginRight: '5px'}">
            <Icon type="ios-arrow-forward" />
          </Button>
          <ul v-show="ServerGroupIsShow" id="serverGroupZTree" class="ztree"></ul>
        </Card>
      </Col>
      <div id="rMenu" style="z-index: 1999;">
        <a href="#" class="list-group-item" @click="editServerBtn">绑定设备</a>
        <a href="#" class="list-group-item" @click="expand">展开下一级</a>
        <a href="#" class="list-group-item" @click="expandSon">展开所有子节点</a>
        <a href="#" class="list-group-item" @click="collapse">折叠子节点</a>
        <a href="#" class="list-group-item" @click="openAll">全部展开</a>
        <a href="#" class="list-group-item" @click="collapseAll">全部折叠</a>
      </div>

      <Col v-bind:span="serverTableSpan">
        <Card>
          <Row>
            <Col span="24">
            <Form :model="searchForm" ref="searchForm" inline :label-width="60">
              <FormItem label="品牌" :label-width="40">
                <Select v-model="searchForm.brand" style="min-width:200px" clearable>
                  <Option v-for="item in brandList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="设备名称">
                <Input v-model="searchForm.name" style="min-width: 200px" />
              </FormItem>
              <FormItem label="设备类型">
                <Select v-model="searchForm.asset_type" style="min-width:200px" clearable>
                  <Option v-for="item in assetTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="设备管理地址" :label-width="85">
                <Input v-model="searchForm.asset_ip" style="min-width: 200px" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getServers()">搜索</Button>
                <Button style="margin-left: 8px" @click="searchReset">重置</Button>
              </FormItem>
            </Form>
            </Col>
          </Row>

          <row>
            <div style="float: right">
              <ButtonGroup style="margin-bottom: 10px">
                <Button type="primary" v-show="isNetworkAdd" @click="serverChangeModal = true; serverChangeModalTitle = '添加网络设备'">添加网络设备</Button>
                <Button type="primary" @click="execModalOpen" :loading="scanServerLoading">批量备份配置</Button>
                <Button type="primary" @click="execSyncModalOpen" :loading="syncServerLoading">同步数据</Button>
              </ButtonGroup>
              <!-- <Button style="margin: 0 10px 10px" v-show="isNetworkEdit" type="warning" icon="ios-create-outline" @click="serverChangeModifyModalOpen">编辑</Button> -->
              <Button style="margin-bottom: 10px" v-show="isNetworkDelete" type="error" icon="ios-trash-outline" @click="serverRemove">批量删除</Button>
            </div>
          </row>

          <Row>
            <Table
              ref="table"
              size="small"
              :columns="columns"
              @on-selection-change="selectChange"
              :data="tableData"
              :loading="table_loading"
              class="mob-remove-table-fixed"
            ></Table>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: right;">
                <page :total="count" :current="page" :page-size="size" @on-change="getServers"></page>
              </div>
            </div>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>
<script>
import {getNetworkServerGroup, changeNetworkServerGroup, deleteNetworkServerGroup,
  getNetworkServer, getNetworkAllServer, changeNetworkServer, scanServer, syncServer} from '@/api/network'
import {ClientIdentifier} from '@/libs/clientIdentifier'
import config from '@/config'
import ConfigBackupModal from './config-backup-modal'
import ConfigSyncModal from './config-sync-modal'

const guacamoleUrl = config.guacamoleUrl

export default {
  name: 'asset-manage',
  components: {
    ConfigBackupModal,
    ConfigSyncModal
  },
  data () {
    return {
      assetTypeList: [
        // {
        //   value: 0,
        //   label: '软件'
        // },
        // {
        //   value: 1,
        //   label: '硬件'
        // },
        {
          value: 2,
          label: '交换设备'
        },
        {
          value: 3,
          label: '路由设备'
        },
        {
          value: 4,
          label: '防火墙'
        },
        {
          value: 5,
          label: '负载均衡'
        }
        // {
        //   value: 9,
        //   label: '未知'
        // }
      ],
      protocalList: [
        {
          value: 'ssh',
          label: 'ssh'
        },
        {
          value: 'telnet',
          label: 'telnet'
        }
      ],
      brandList: [
        {
          value: 'Cisco',
          label: 'Cisco'
        },
        {
          value: 'H3C',
          label: 'H3C'
        },
        {
          value: 'HUAWEI',
          label: 'HUAWEI'
        },
        {
          value: 'OmniSwitch',
          label: 'OmniSwitch'
        },
        {
          value: 'Avaya',
          label: 'Avaya'
        },
        {
          value: 'Fortigate',
          label: 'Fortigate'
        },
        {
          value: 'A10',
          label: 'A10'
        }
      ],
      tableDataSel: [],
      winrmVisible: true,
      polling: null,
      countScanSel: 0,
      countScan: 0,
      tableDataScan: [],
      tableDataScanSel: [],
      table_loadingScan: false,
      countScanHostNameSel: 0,
      countScanHostName: 0,
      tableDataScanHostName: [],
      tableDataScanHostNameSel: [],
      table_loadingScanHostName: false,
      defaultScanIndex: 'scanIP',
      isNetworkAdd: false,
      isNetworkEdit: false,
      isNetworkDelete: false,
      isServerView: false,
      ServerGroupIsShow: true,
      serverGroupSpan: 5,
      serverTableSpan: 19,
      screenWidth: document.body.clientWidth,
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      searchForm: {
        id__in: '',
        name: '',
        asset_type: '',
        asset_ip: '',
        brand: ''
      },
      count: 1,
      page: 1,
      size: 13,
      selectRow: '',
      systemUsersAll: [],
      systemUsersSel: '',
      systemUserKeySel: '',
      conProtocolType: '',
      conHostOs: '',
      userPermDetail: [],
      defaultIp: 'public',
      defaultSelIp: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          minWidth: 100,
          title: '设备名称',
          tooltip: true,
          fixed: 'left',
          key: 'name',
          align: 'center',
          render: (h, params) => {
            let name = params.row.name
            if (!name) {
              name = '未识别'
            }
            return h('router-link', {
              props: {
                to: {
                  name: 'asset-detail',
                  query: { id: params.row.id }
                }
              }
            }, name)
          }
        },
        {
          minWidth: 100,
          title: '设备类型',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 2: '交换设备', 3: '路由设备', 4: '防火墙', 5: '负载均衡', 9: '未知' }
            return h('div', k[params.row.asset_type])
          }
        },
        {
          minWidth: 110,
          title: '设备管理地址',
          align: 'center',
          key: 'asset_ip'
        },
        {
          minWidth: 150,
          title: '设备软件版本号',
          align: 'center',
          key: 'version'
        },
        {
          minWidth: 180,
          title: '设备镜像名称',
          align: 'center',
          key: 'mirror'
        },
        {
          minWidth: 180,
          title: '正常运行时长',
          align: 'center',
          tooltip: true,
          key: 'run_time'
        },
        {
          minWidth: 130,
          title: '品牌',
          align: 'center',
          key: 'brand'
        },
        // {
        //   minWidth: 160,
        //   title: '凭证',
        //   align: 'center',
        //   key: 'certificate',
        //   render: (h, params) => {
        //     if (params.row.certificate) {
        //       // 取凭证数组里面 is_admin 是true的名字
        //       let cerAdmin = params.row.certificate.filter(item => item.is_admin === true)
        //       if (cerAdmin.length > 0) {
        //         return h('div', cerAdmin[0].name)
        //       }
        //     } else {
        //       return ''
        //     }
        //   }
        // },
        {
          minWidth: 80,
          title: '操作',
          align: 'center',
          fixed: 'right',
          key: '',
          // fixed: "right",
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: this.isNetworkEdit
                },
                on: {
                  click: () => {
                    this.serverChangeModifyModalOpen(params)
                  }
                }
              }, '编辑')
            ])
          }
        }
      ],
      tableData: [],
      table_loading: false,
      newCount: 1,
      zTreeSetting: {
        view: {
          addHoverDom: this.addHoverDom,
          removeHoverDom: this.removeHoverDom,
          selectedMulti: false,
          showTitle: false
        },
        edit: {
          enable: true,
          editNameSelectAll: true,
          showRemoveBtn: true,
          showRenameBtn: true
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          },
          key: {
            title: '22222'
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick,
          beforeDrag: this.beforeDrag,
          beforeRemove: this.beforeRemove,
          beforeRename: this.beforeRename,
          onRemove: this.onRemove,
          onRename: this.onRename
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }],
      editServerModal: false,
      editServerModalTitle: '绑定设备',
      no_select_server: [],
      editServerForm: {
        id: 0,
        name: '',
        server: [],
        parent_id: 0
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      serverChangeModal: false,
      serverForm: {
        id: 0,
        asset_ip: '',
        admin_user: '',
        admin_pwd: '',
        // community: '',
        asset_type: '',
        protocol: '',
        brand: '',
        port: '',
        description: ''
      },
      serverFormRule: {
        name: [
          { required: true, message: '设备名不能为空', trigger: 'blur' }
        ],
        asset_type: [
          { required: true, message: '设备类型不能为空 !', trigger: 'change', type: 'number' }
        ],
        protocol: [
          { required: true, message: '协议类型不能为空 !', trigger: 'change' }
        ],
        brand: [
          { required: true, message: '品牌不能为空 !', trigger: 'change' }
        ],
        port: [
          { required: true, type: 'number', message: '端口不能为空、且必须为数字', trigger: 'blur' }
        ],
        admin_user: [
          { required: true, message: '管理员账号不能为空', trigger: 'blur' }
        ],
        admin_pwd: [
          { required: true, message: '管理员密码不能为空', trigger: 'blur' }
        ]
        // community: [
        //   { required: true, message: 'SNMP Community 不能为空', trigger: 'blur' }
        // ]
        // name: [
        //   { required: true, message: '实例名称不能为空', trigger: 'blur' }
        // ]
      },
      serverChangeModalTitle: '添加网络设备',
      allSupportList: [],
      allCertificateList: [],
      collectForm: {
        support: '',
        region: ''
      },
      scanForm: {
        network: '',
        hosts: []
      },
      scanHostNameForm: {
        hosts: []
      },
      collectRule: {
        support: [
          { require: true, message: '服务商不能为空', trigger: 'blur' }
        ]
      },
      scanRule: {
        // network: [
        //   { require: true, message: '扫描网段/ip不能为空', trigger: 'blur' }
        // ]
      },
      collectServerLoading: false,
      scanServerLoading: false,
      syncServerLoading: false,
      scanServerOkLoading: false,
      scanServerOkDisabled: true,
      scanHostNameLoading: false,
      allRegionList: [],
      regionList: [],
      collectModal: false,
      scanModal: false,
      scanHostNameModal: false
    }
  },
  updated () {
    console.log('updated')
  },
  mounted: function () {
    console.log('mounted')
    this.initOperatePerm()
    this.getServers()
    this.getServerGroup()
    this.getAllServers()
    this.getAllSupport()
    this.getAllCertificate()
    this.getRegionList()
  },
  methods: {
    // 切换凭证协议，默认给端口赋值
    handleCertificate (value) {
      // 0--密码 1 - 密钥
      if (value === 'ssh') {
        this.serverForm.port = 22
      } else if (value === 'telnet') {
        this.serverForm.port = 23
      }
    },
    selectChange (selection) {
      this.tableDataSel = selection
    },
    onSelectOs (value) {
      if (value === 0) {
        this.winrmVisible = false
        this.serverForm.winrm_port = null
      } else if (value === 1) {
        this.winrmVisible = true
        this.serverForm.winrm_port = 5986
      }
    },
    pollData () {
      this.polling = setInterval(() => {
        this.getScanHostList()
      }, 3000)
    },
    // 打开执行Modal
    execModalOpen () {
      this.$refs.ConfigBackupModal.openModal()
    },
    // 打开同步数据Modal
    execSyncModalOpen () {
      this.$refs.ConfigSyncModal.openModal()
    },
    handleScan (val) {
      console.log(val)
      if (val.length > 0) {
        this.scanServerLoading = true
        let data = { hosts: val }
        console.log(data)
        scanServer(data).then(res => {
          console.log(res)
          let result = res.data
          if (result.code === 200) {
            console.log(result.data)
          } else {
            this.$Notice.error({
              title: '扫描失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          this.scanServerLoading = false
        }).catch(res => {
          this.scanServerLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '至少选择一台设备进行扫描 ！' })
      }
    },
    syncServer (val) {
      console.log(val)
      this.syncServerLoading = true
      let data = { hosts: val }
      syncServer(data).then(res => {
        console.log(res)
        let result = res.data
        if (result.code === 200) {
          console.log(result.data)
        } else {
          this.$Notice.error({
            title: '扫描失败！失败状态码:' + result.code,
            desc: result.msg
          })
        }
        this.syncServerLoading = false
      }).catch(res => {
        this.syncServerLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '收集失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    selectChangeScan (selection) {
      this.tableDataScanSel = selection
      this.countScanSel = this.tableDataScanSel.length
      this.scanForm.hosts = this.tableDataScanSel
      // this.$emit('on-result-change', this.tableDataSel)
    },
    selectChangeScanHostName (selection) {
      this.tableDataScanHostNameSel = selection
      this.countScanHostNameSel = this.tableDataScanHostNameSel.length
      this.scanHostNameForm.hosts = this.tableDataScanHostNameSel.map(item => item.id)
      // this.$emit('on-result-change', this.tableDataSel)
    },
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      // 手机端设置
      if (this.screenWidth < 768) {
        this.serverGroupSpan = 24
        this.serverTableSpan = 24
      }
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_network') > -1) {
        this.isNetworkAdd = true
      } else {
        this.isNetworkAdd = false
      }
      if (permissions.indexOf('change_network') > -1) {
        this.isNetworkEdit = false
      } else {
        this.isNetworkEdit = true
      }
      if (permissions.indexOf('delete_network') > -1) {
        this.isNetworkDelete = true
      } else {
        this.isNetworkDelete = false
      }
    },
    ServerGroupShowBtn (status) {
      this.ServerGroupIsShow = status
      if (status) {
        this.serverGroupSpan = 5
        this.serverTableSpan = 19
      } else {
        this.serverGroupSpan = 1
        this.serverTableSpan = 23
      }
    },
    getServers (value = 1) {
      this.page = value
      this.table_loading = true
      this.searchForm['size'] = this.size
      this.searchForm['page'] = this.page
      getNetworkServer(this.searchForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.count = result.count
        this.tableData = tableData
        this.table_loading = false
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取设备列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getAllServers () {
      getNetworkAllServer().then(res => {
        let result = res.data
        this.no_select_server = []
        for (let i in result) {
          this.no_select_server.push({
            key: result[i].id,
            label: result[i].name
          })
        }
      })
    },
    getAllScanServers () {
      getNetworkAllScanServer().then(res => {
        let result = res.data
        this.tableDataScanHostName = result
        this.countScanHostName = result.length
      })
    },
    getServerGroup () {
      getNetworkServerGroup().then(res => {
        this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取设备组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeServerSubmit () {
      this.$refs['serverForm'].validate((valid) => {
        if (valid) {
          let regxp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
          if (this.serverForm.asset_ip) {
            if (!regxp.test(this.serverForm.asset_ip)) {
              this.$Notice.error({ title: '私有ip地址格式错误' })
              return false
            }
          }
          changeNetworkServer(this.serverForm, this.serverForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.serverChangeModalClose()
            this.getServers(this.page)
            this.getAllServers()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getAllCertificate () {
      getNetworkAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    searchReset () {
      this.searchForm.name = ''
      this.searchForm.asset_type = ''
      this.searchForm.asset_ip = ''
      this.searchForm.brand = ''
    },
    changeFormReset () {
      this.serverForm.id = 0
      this.serverForm.asset_ip = ''
      this.serverForm.admin_user = ''
      this.serverForm.admin_pwd = ''
      this.serverForm.protocol = ''
      this.serverForm.brand = ''
      this.serverForm.port = ''
      // this.serverForm.community = ''
      this.serverForm.description = ''
    },
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#serverGroupZTree'), this.zTreeSetting, this.zNodes)
    },
    zTreeOnClick (event, treeId, treeNode) {
      console.log(treeNode)
      if (treeNode.id === 0) {
        this.searchForm.id__in = ''
      } else {
        // let childNodes = this.getChildNodes(treeNode)
        let childNodes = treeNode.server
        console.log(childNodes)
        if (childNodes) {
          this.searchForm.id__in = childNodes
        } else {
          this.searchForm.id__in = 99999999
        }
      }
      this.getServers()
    },
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      return nodes.join(',')
    },
    OnRightClick (event, treeId, treeNode) {
      if (!treeNode && event.target.tagName.toLowerCase() !== 'button' && $(event.target).parents('a').length === 0) {
        this.zTree.cancelSelectedNode()
        this.showRMenu('root', event.clientX, event.clientY)
      } else if (treeNode && !treeNode.noR) {
        this.zTree.selectNode(treeNode)
        this.showRMenu('node', event.clientX, event.clientY)
      }
    },
    showRMenu (type, x, y) {
      $('#rMenu ul').show()
      $('#rMenu').css({ 'top': y - 60 + 'px', 'left': x - 250 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      if ($('#rMenu')) $('#rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#rMenu').length > 0)) {
        $('#rMenu').css({ 'visibility': 'hidden' })
      }
    },
    expand () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, null, null)
    },
    expandSon () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, true, null)
    },
    collapse () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], false, null, null)
    },
    collapseAll () {
      this.hideRMenu()
      this.zTree.expandAll(false)
    },
    openAll () {
      this.hideRMenu()
      this.zTree.expandAll(true)
    },
    addHoverDom (treeId, treeNode) {
      let that = this
      let sObj = $('#' + treeNode.tId + '_span')
      if (treeNode.editNameFlag || $('#addBtn_' + treeNode.tId).length > 0) return
      let addStr = "<span class='button add' id='addBtn_" + treeNode.tId + "' title='add node' onfocus='this.blur();'></span>"
      sObj.after(addStr)
      let btn = $('#addBtn_' + treeNode.tId)
      if (btn) {
        btn.bind('click', function () {
          let newName = '新分组' + (that.newCount++)
          let reqData = { 'name': newName, 'parent_id': treeNode.id }
          changeNetworkServerGroup(reqData).then(res => {
            let result = res.data
            let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
            zTree.addNodes(treeNode, { id: result['id'], pId: result['parent_id'], name: result['name'] })
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '添加设备组失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        })
      }
    },
    removeHoverDom (treeId, treeNode) {
      $('#addBtn_' + treeNode.tId).unbind().remove()
    },
    showRemoveBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    showRenameBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    beforeRemove (treeId, treeNode) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可删除'
        })
        return false
      }
      let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
      zTree.selectNode(treeNode)
      return confirm('确认删除「' + treeNode.name + '」分组吗？')
    },
    onRemove (e, treeId, treeNode) {
      deleteNetworkServerGroup(treeNode.id).then(res => {
        that.$Notice.success({
          title: '删除成功！'
        })
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '删除失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    beforeRename (treeId, treeNode, newName) {
      if (newName.length === 0) {
        that.$Notice.error({
          title: '节点名称不能为空'
        })
        return false
      }
      return true
    },
    beforeDrag (treeId, treeNodes) {
      return false
    },
    onRename (e, treeId, treeNode, isCancel) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      let reqData = { 'name': treeNode.name }
      changeNetworkServerGroup(reqData, treeNode.id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerBtn () {
      let selectNodes = this.zTree.getSelectedNodes()
      if (selectNodes[0]['id'] === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      this.hideRMenu()
      this.editServerModalTitle = '「' + selectNodes[0]['name'] + '」绑定设备'
      this.editServerModal = true
      this.editServerForm.id = selectNodes[0]['id']
      this.editServerForm.name = selectNodes[0]['name']
      this.editServerForm.server = selectNodes[0]['server_list']
      this.editServerForm.parent_id = selectNodes[0]['parent_id']
    },
    editServerForGroupSubmit () {
      let reqData = {
        id: this.editServerForm.id,
        name: this.editServerForm.name,
        server: this.editServerForm.server.join(','),
        parent_id: this.editServerForm.parent_id
      }
      changeNetworkServerGroup(reqData, this.editServerForm.id).then(res => {
        this.editServerModal = false
        this.editServerModalCancel()
        this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }]
        this.getServerGroup()
        this.searchForm.id__in = ''
        this.getServers()
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerModalCancel () {
      this.editServerForm.id = 0
      this.editServerForm.name = ''
      this.editServerForm.server = []
      this.editServerForm.parent_id = 0
    },
    editServerChange (newKeyList) {
      this.editServerForm.server = newKeyList
    },
    serverChangeModalClose () {
      this.serverChangeModal = false
      this.changeFormReset()
    },
    serverChangeModifyModalOpen (params) {
      this.selectRow = params.row
      if (this.selectRow) {
        this.serverForm.id = this.selectRow.id
        this.serverForm.asset_ip = this.selectRow.asset_ip
        this.serverForm.admin_user = this.selectRow.admin_user
        this.serverForm.admin_pwd = this.selectRow.admin_pwd
        this.serverForm.asset_type = this.selectRow.asset_type
        this.serverForm.protocol = this.selectRow.protocol
        this.serverForm.brand = this.selectRow.brand
        this.serverForm.port = this.selectRow.port
        // this.serverForm.community = this.selectRow.community
        this.serverForm.description = this.selectRow.description
        this.serverChangeModalTitle = '编辑网络设备：' + this.selectRow.asset_ip
        this.serverChangeModal = true
      } else {
        this.$Notice.error({
          title: '请选择一台设备'
        })
      }
    },
    rowClick (data, index) {
      let oldStatus = this.tableData[index].checkBox
      this.tableData.forEach((items) => {
        this.$set(items, 'checkBox', false)
      })
      this.tableData[index].checkBox = !oldStatus
      if (this.tableData[index].checkBox) {
        this.selectRow = data
      } else {
        this.selectRow = ''
      }
    },
    serverRemove () {
      let delHost = this.tableDataSel.map(item => item.name)
      if (delHost.length > 0) {
        console.log(delHost.join(','))
        this.$Modal.confirm({
          title: '删除',
          content: '确定要删除设备「' + delHost.join(',') + '」吗?',
          onOk: () => {
            for (let i in this.tableDataSel) {
              this.selectRow = this.tableDataSel[i]
              try {
                if (this.selectRow) {
                  this.selectRow['is_delete'] = true
                  if (!this.selectRow.name) {
                    this.selectRow.name = '未知'
                  }
                  if (this.selectRow.support) {
                    this.selectRow.support = this.selectRow.support.id
                  }
                  if (this.selectRow.certificate) {
                    this.selectRow.certificate = this.selectRow.certificate.map(item => item.id)
                  }
                  changeNetworkServer(this.selectRow, this.selectRow.id).then(res => {
                    this.getServers()
                  }).catch(res => {
                    if (res.request) {
                      // that.$Notice.error({
                      //   title: '删除失败！请求状态码:' + res.request.status,
                      //   desc: res.request.responseText
                      // })
                      // console.log(111)
                    }
                  })
                }
              } catch (e) {
                console.log(e)
              }
            }
            this.$Notice.success({
              title: '删除成功！'
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '至少选择一台设备进行删除'
        })
      }
    },
    getRegionList () {
      getRegion().then(res => {
        let result = res.data
        this.allRegionList = result.result
      })
    },
    supportChange (select) {
      let type = 4
      for (let i in this.allSupportList) {
        if (this.allSupportList[i].id === select) {
          type = this.allSupportList[i].type
          break
        }
      }
      this.regionList = []
      this.collectForm.region = ''
      if (type === 1) {
        this.regionList = this.allRegionList.aliyun_region_list
      } else if (type === 2) {
        this.regionList = this.allRegionList.ucloud_region_list
      } else if (type === 3) {
        this.regionList = this.allRegionList.aws_region_list
      }
    },
    collectSubmit () {
      this.collectServerLoading = true
      collectServer(this.collectForm).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '收集成功',
            desc: result.data
          })
          this.collectModal = false
          this.getServers()
        } else {
          this.$Notice.error({
            title: '收集失败！失败状态码:' + result.code,
            desc: result.msg
          })
        }
        this.collectServerLoading = false
      }).catch(res => {
        this.collectServerLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '收集失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getScanHostList () {
      let params = {
        search: this.uid
      }
      getAllScanTmp(params).then(res => {
        this.tableDataScan = res.data
        this.countScan = res.data.length
        this.countScanSel = 0
        let result = res.data.filter(item => item.os === 9)
        if (!result.length) {
          clearInterval(this.polling)
          this.scanServerLoading = false
          this.scanServerOkDisabled = false
        }
      })
    },
    scanSubmit (name) {
      if (this.scanForm.network !== '') {
        this.scanServerLoading = true
        scanServer(this.scanForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            console.log(result.data)
            this.uid = result.data
            this.pollData()
            // this.getScanHostList()
            // this.countScan = result.data.length
            // this.tableDataScan = result.data.map((value, index, array) => {
            //   return { 'inner_ip': value }
            // })
          } else {
            this.$Notice.error({
              title: '扫描失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          // this.scanServerLoading = false
        }).catch(res => {
          this.scanServerLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '扫描网段/ip不能为空 ！' })
      }
    },
    // 导入选中的设备
    scanConfirmSubmit (name) {
      if (this.scanForm.hosts.length !== 0) {
        this.scanServerOkLoading = true
        scanServerOk(this.scanForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.$Notice.success({
              title: '导入成功',
              desc: result.data
            })
            this.scanModal = false
            this.getServers()
          } else {
            this.$Notice.error({
              title: '导入失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          this.scanServerOkLoading = false
        }).catch(res => {
          this.scanServerOkLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '至少选择一个设备进行导入 ！' })
      }
    },
    scanHostNameSubmit () {
      if (this.scanHostNameForm.hosts.length !== 0) {
        this.scanHostNameLoading = true
        console.log(this.scanHostNameForm)
        scanHostName(this.scanHostNameForm).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.$Notice.success({
              title: '扫描成功',
              desc: result.data
            })
            this.scanModal = false
            this.getServers()
          } else {
            this.$Notice.error({
              title: '扫描失败！失败状态码:' + result.code,
              desc: result.msg
            })
          }
          this.scanHostNameLoading = false
        }).catch(res => {
          this.scanHostNameLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '收集失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Notice.error({ title: '至少选择一个设备获取设备名 ！' })
      }
    },
    getNowTime (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let hour = date.getHours() + ':'
      let minute = date.getMinutes() + ':'
      let second = date.getSeconds()
      let nowTime = year + '-' + month + '-' + day
      if (type !== 'date') {
        nowTime += ' ' + hour + minute + second
      }
      return nowTime
    },
    daysBetween (sDate1) {
      let time1 = Date.parse(new Date(sDate1))
      let time2 = Date.parse(new Date(this.getNowTime('date')))
      let nDays = parseInt((time1 - time2) / 1000 / 3600 / 24)
      if (time1 > time2) {
        return nDays
      } else {
        return -nDays
      }
    },
    connetRemoteAsset (ip) {
      // 调用后台创建 guacamole connect ，将返回id直接传到下面url中，连接远程机器，无需管 ops和 guacamole数据同步，目的是连接远程机器，权限在ops这边控制
      // let name = this.systemUsersSel
      let data = {
        ip: ip,
        username: this.systemUsersSel,
        key: this.systemUserKeySel,
        os: this.conHostOs,
        keyType: this.conProtocolType
      }
      getConnectId(data).then(res => {
        if (res.status === 200) {
          console.log(res.data)
          let connectId = ClientIdentifier(parseInt(res.data))
          console.log(connectId)
          // window.location.href = 'http://opsdeep.aukeyit.com/guacamole/#/client/' + connectId
          // let url = 'http://10.1.2.127:8080/guacamole/#/client/' + connectId
          let url = guacamoleUrl + '/guacamole/#/client/' + connectId
          let h = window.screen.availHeight
          let w = window.screen.availWidth
          window.open(url, '堡垒机', 'left=0,top=0,width=' + w + ',height=' + h + ',directories=no,location=no,toolbar=no,menubar=no,status=no,scrollbars=no,titlebar=no,resizable=no')
        } else {
          this.$Message.error('获取连接信息失败，请核查数据')
        }
      })
    },
    // 远程连接
    handleConnect (params) {
      // 先判断用户是否有权限连接当前这台设备if (this.$store.state.user.superuser) {
      // let paramsPerm = {
      //   username: this.$store.state.user.userName
      // }
      this.conHostOs = params.row.os
      getUserHostPerm().then(res => {
        // console.log(res.data)
        let canCon
        this.userPermDetail = res.data.map(item => item[0])
        let sysUsers = res.data.filter(item => item[0] === params.row.id)
        if (this.$store.state.user.superuser) {
          if (this.userPermDetail.indexOf(params.row.id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '设备未绑定凭证',
              content: '该设备未绑定任何凭证，请先绑定凭证然后再连接 ！'
            })
          }
        } else {
          if (this.userPermDetail.indexOf(params.row.id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '无操作权限',
              content: '您没有该设备的连接权限，请联系管理员开通 ！'
            })
          }
        }
        if (!canCon) {
        } else {
          // 弹出系统用户选择框
          if (sysUsers) {
            this.systemUsersAll = sysUsers.map(item => item[1])
            this.systemUsersSel = this.systemUsersAll[0]
            this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
            this.conProtocolType = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[3])[0]
            // console.log(this.systemUserKeySel)
          } else {
            this.$Message.error('系统异常，取不到当前用户，当前设备所对应的系统用户，请检查权限数据')
          }
          // 判断公网ip 私有ip 给defaultIp 赋值
          if (params.row.public_ip || params.row.inner_ip) {
            this.defaultIp = params.row.public_ip ? 'public' : 'private'
            this.defaultSelIp = params.row.public_ip ? params.row.public_ip : params.row.inner_ip
          } else {
            this.$Message.error('系统异常，公有IP,私有IP都为空,请检查凭证ip数据')
            return
          }
          this.$Modal.confirm({
            width: '500px',
            title: '远程连接',
            onOk: () => {
              if (this.defaultSelIp) {
                this.connetRemoteAsset(this.defaultSelIp)
              } else {
                this.$Message.error('ip为空，不能建立连接,请检查凭证ip数据')
              }
            },
            render: (h) => {
              return h('div', [
                h('Divider'),
                h('span', { style: { color: '#515a6e' } }, '连接IP：'),
                h('RadioGroup', {
                  props: {
                    type: 'button',
                    value: this.defaultIp
                  },
                  style: { marginLeft: '58px' },
                  on: {
                    'on-change': (val) => {
                      if (val === 'private') {
                        this.defaultSelIp = ''
                        if (params.row.inner_ip) {
                          this.defaultSelIp = params.row.inner_ip
                        } else {
                          this.$Message.error('内部ip为空，不能建立连接')
                        }
                      } else {
                        this.defaultSelIp = ''
                        if (params.row.public_ip) {
                          this.defaultSelIp = params.row.public_ip
                        } else {
                          this.$Message.error('外部ip为空，不能建立连接')
                        }
                      }
                    }
                  }
                }, [
                  h('Radio', {
                    props: {
                      label: 'private'
                    } }, '内部IP'),
                  h('Radio', {
                    props: {
                      label: 'public'
                    } }, '外部IP')
                ]),
                h('br'),
                h('br'),
                h('span', { style: { color: '#515a6e' } }, '请选择凭证用户：'),
                h('Select', {
                  props: {
                    value: this.systemUsersSel
                  },
                  on: {
                    'on-change': (value) => {
                      this.systemUsersSel = value
                      this.systemUserKeySel = sysUsers.filter(item => item[1] === this.systemUsersSel).map(item => item[2])[0]
                    }
                  },
                  style: {
                    width: '200px'
                  }
                },
                this.systemUsersAll.map(function (item) {
                  return h('Option', {
                    props: { value: item }
                  }, item)
                })
                ),
                h('Divider')
              ])
            }
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  created: function () {
    console.log('server created')
  }
  // destroyed () {
  //   let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
  //   zTree.refresh()
  // }
}
</script>

<style lang="scss">
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }

  @media screen and (min-width:768px){
    .tree-style{
      .ivu-row{
        padding-left: 0!important;
        padding-top:0!important;
        padding-bottom: 0!important;
      }
    }
  }
  .tree-style{
    .ztree *{
      font-size:14px;
    }
    .ztree li span.button.ico_open,
    .ztree li span.button.ico_close,
    .ztree li span.button.ico_docu,
    {
      display: none;
    }
    .ztree li span.button.root_close {
      background-position: -126px -65px;
    }
    .ztree li span.button.root_open {
      background-position: -105px -65px;
    }
    .ztree li span.button.center_close{
      background-position: -126px -23px;
    }
    .ztree li span.button.bottom_close {
      background-position: -126px -45px;
    }
    .ztree li span.button.bottom_open {
      background-position: -105px -45px;
    }
    .ztree li span.button.center_open {
      background-position: -105px -23px;
    }
    .ivu-col-span-1,.ivu-col-span-5{
      padding-top:16px;
      padding-bottom:10px;
    }
    .ivu-col-span-5{
      // border-right: 6px solid rgba(0, 0, 0, 0.3);
      margin-right:-6px;
      width: 18%;
    }
    .ivu-col-span-23{
      padding-top:16px!important;
    }
    .ztree li{
      line-height: 29px;
      ul{
        padding:0;
        li{
          padding:0 0 0 12px;
        }
      }
      a{
        height: 29px;
        width:65%;
        span.button{
          margin-top:7px;
        }
        &.curSelectedNode{
          background:none;
          color:#2d8cf0;
          span.button{
            display: none;
          }
          &:hover{
              span.button.add,
              span.button.edit,
              span.button.remove{
              display: inline-block;
            }
          }
        }
      }
    }
    .ztree li ul.line{
      background:none;
    }
    .ztree li span.button{
      background-image:url("../../assets/images/metro1.png");
    }
    .ztree li span.button.center_open{
      position: relative;
    }
    .ivu-col-span-19{
      padding-top:16px;
      padding-left: 20px;
      width: 82%;
    }
  }
  .asset-manage{
    .ivu-col-span-1{
      .ivu-btn-primary{
        margin-right: -8px!important;
      }
    }
    .ivu-card-bordered{
      .ivu-card-body{
        display: flow-root;
        clear: both;
      }
    }
  }
</style>
<style scoped>
  @media screen and (max-width:640px){
    .ivu-input-wrapper,.ivu-select{
      min-width: initial!important;
    }
    .scanBtn{
      margin-top:5px;
    }
  }
</style>
